import { stationEntity } from "../domain/entities/station_entity";
import http from "../../../plugins/http-common"
import i18n from "../../../i18n";

export const HttpStationRepository = {
  model: stationEntity,

  async index() {
    const res = await http.get('apollo/stations');
    
    return res.data.success.arguments.map(item => ({
      ...item,
      actions: JSON.parse(JSON.stringify([
        {
            name: i18n.t('stations.detail'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            method: 'show',
            permission: "station.show"
        },
        {
            name: i18n.t('stations.edit'),
            icon: {
                color: 'accent',
                icon: 'edit'
            },
            link: 'station/edit/' + item.id,
            permission: "station.show"
        }
      ])),
      slots_count: item.slots.length,
      parameters: item
    }));
  },

  async show(id) {
    const res = await http.get('apollo/station/' + id);
    
    return res.data.success.arguments;
  },

  async update(id, data){
    const res = await http.patch('apollo/station/' + id, data);

    return res;
  },

  async create(data){
    const res = await http.post('apollo/station/create', data);

    return res;
  }
};